import React, { useEffect, useState } from 'react';
import graph from '../graph';
import Update from '../Update';

import {
  Fade,
  Card,
  Stack,
  Typography,
  CardHeader,
  CardContent,
  CardActions,
  CardActionArea,
  Button,
} from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

import { FormattedMessage } from 'react-intl';
import { AvatarPopover, NewMediaPopup } from 'components';

export default function Model({ model, delay, checked, refetch, isAssign, selectable, handleSelect }) {
  const { id, product_shop, title, product_details, product_image, creator } = model;
  const currentProduct = product_shop?.product_info;

  const handleOpenLink = (url) => {
    window.open(url, '_blank');
  };

  return (
    <>
      {currentProduct && (
        <Fade in unmountOnExit timeout={{ appear: delay * 150, enter: delay * 170, exit: delay * 190 }}>
          <Stack direction="row" alignItems="center">
            <Card
              sx={{
                width: '100%',
                position: 'relative',
                borderColor: checked && 'primary.main',
                bgcolor: checked && 'action.disabledBackground',
              }}
              variant="outlined"
            >
              <CardHeader
                sx={{ p: 1 }}
                avatar={
                  <>
                    <NewMediaPopup
                      id={currentProduct?.id}
                      model="Product"
                      collection="avatar"
                      title={title}
                      graph={graph}
                    >
                      <AvatarPopover
                        isAssign={isAssign}
                        sx={{ width: 48, height: 48 }}
                        media={currentProduct?.media[0]?.full_url}
                      />
                    </NewMediaPopup>
                    {product_image && (
                      <>
                        <KeyboardBackspaceIcon color="info" sx={{ alignSelf: 'center' }} />
                        <Button onClick={() => handleOpenLink(product_image)}>
                          <AvatarPopover isAssign={isAssign} media={product_image} />
                        </Button>
                      </>
                    )}
                  </>
                }
                title={
                  <Stack rowGap={0.5} alignItems="flex-start">
                    <Typography variant="subtitle1">{currentProduct?.title}</Typography>
                    {/* <Typography variant="body2" color="text.secondary">
                      {product_details}
                    </Typography> */}
                    <Typography variant="body2" color="text.secondary">
                      {currentProduct?.barcode}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {`${creator?.firstname} ${creator?.lastname}`}
                    </Typography>
                  </Stack>
                }
              />
              <CardActions sx={{ justifyContent: 'flex-end' }}>
                <Update
                  product_image={product_image}
                  creator={`${creator?.firstname} ${creator?.lastname}`}
                  ids={id}
                  title={<FormattedMessage id="update" />}
                  refetch={refetch}
                />
              </CardActions>
              <CardActionArea
                sx={{
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  zIndex: 1,
                  position: 'absolute',
                }}
                disabled={!isAssign && !selectable}
                onClick={handleSelect}
              />
            </Card>
          </Stack>
        </Fade>
      )}
    </>
  );
}
